import * as apiGetRegions from "@/api/vp/regions/getRegions";

export default {
    namespaced: true,
    state: {
        loading: false,
        regions: [],
    },
    mutations: {
        gotRegions(state, result) {
            state.regions = result;
        },
        isLoading(state, loading) {
            state.loading = loading;
        }
    },
    actions: {
        async getAll({ commit }) {
            commit("isLoading", true);

            const result = await apiGetRegions.get();

            if (result) {
                commit("gotRegions", result);
            }

            commit("isLoading", false);
        },
    },
    getters: {
        regions: state => state.regions,
    }
}

